module.exports = __webpack_public_path__ + "img/6fae949.png";